import React, { useContext, useEffect } from "react";
import BusinessContext from "context/BusinessContext";
import CreateComment from "./Comments";
import { CommentList } from "./Comments";
const ModalCustomerMessages = () => {
  const { comments } = useContext(BusinessContext);
  return (
    <div
      className="modal fade"
      id="CustomerMessages"
      tabIndex="-1"
      aria-labelledby="CustomerMessagesLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="CustomerMessagesLabel">
              نظرات مشتریان
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <CreateComment isProduct={false} />
            <CommentList commentLists={comments} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModalCustomerMessages;
